module.exports = __webpack_public_path__ + "assets/img/EKS-Score.9732c022.svg";